import { Expose } from 'class-transformer';

// Enum

export enum UploadFileTypeEnum {
  DocumentSaleVisaGuestDetail = 'DocumentSaleVisaGuestDetail',
  DocumentSalePassportGuestDetail = 'DocumentSalePassportGuestDetail',
  DocumentSaleInsuranceGuestDetail = 'DocumentSaleInsuranceGuestDetail',
  DocumentSaleApecCardGuestDetail = 'DocumentSaleApecCardGuestDetail',
  GuestVisa = 'GuestVisa',
  GuestPassport = 'GuestPassport',
  GuestInsurance = 'GuestInsurance',
  GuestApecCard = 'GuestApecCard',
  GuestVaccine = 'GuestVaccine',
  GuestOtherDocument = 'GuestOtherDocument',
  ApprovalItem = 'ApprovalItem',
}

// Model

export class UploadFileParam {
  id: string;
  attributes: {
    action: string;
    method: string;
    enctype: string;
  };
  inputs: string;

  @Expose({ name: 'file_name' })
  fileName: string;
}

// Input

export type UploadInput = {
  contentType: string;
  type: UploadFileTypeEnum;
};
